import { createReducer, on } from '@ngrx/store';

import { shelfAction } from './shelf.actions';
import { ShelfBarcodeContentPagination, ShelfSequenceList } from '../models/shelf-list.model';

export const shelfKey = 'shelf';

export interface ShelfState {
  shelfList: any;
  shelfSequenceList: {
    content: ShelfSequenceList[];
    totalElements: number;
  };
  shelfSequenceResponse: any;
  shelfBarcodeList: ShelfBarcodeContentPagination;
}

export const initialState: ShelfState = {
  shelfList: null,
  shelfSequenceList: {
    content: [],
    totalElements: null
  },
  shelfSequenceResponse: null,
  shelfBarcodeList: null
};

export const shelfReducer = createReducer<ShelfState>(
  initialState,
  on(shelfAction.shelfListResponse, (state, response) => {
    return { ...state, shelfList: response.response };
  }),
  on(shelfAction.shelfSequenceListResponse, (state, response) => {
    return {
      ...state,
      shelfSequenceList: {
        content: response.response,
        totalElements: response.response.length
      }
    };
  }),
  on(shelfAction.shelfSequenceSubmitRequest, (state) => {
    return { ...state, shelfSequenceResponse: null };
  }),
  on(shelfAction.shelfSequenceSubmitResponse, (state, response) => {
    return { ...state, shelfSequenceResponse: response.response };
  }),
  on(shelfAction.shelfBarcodePrintListResponse, (state, response) => {
    return { ...state, shelfBarcodeList: response.response };
  })
);
